
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../../hooks/hooks';
import storePersist from '../../../../redux/storePersist';
import { login } from '../../../../redux/auth/actions';
import { userProfile } from '../../../../redux/userProfile/action';
import { getAccountTypeChannalName } from '../../../../common/services/common.service';

export const GoogleAuthRegisteredPage =() =>{
  const navigate = useNavigate()
	const dispatch = useAppDispatch()
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
      };

	  const query = useQuery();
	  const digitUserId = query.get('digiit-userid');

    const cleanUp = () => {
      localStorage.removeItem('access-token')
      localStorage.removeItem('accessTokenMetadata')
      localStorage.removeItem('userProfile')
	  localStorage.removeItem('google-login-role')   
    }
	  
	const gotoHome = (role: any) => {
		switch (role?.toLocaleLowerCase()){
			case 'logistics_customer':		
				navigate('/customer/home')
				break;
			case 'transporter':		
				navigate('/transporter/home')
				break;
			case 'employee':
				navigate('/management/home')
				break;
			case 'transportAgent':
				navigate('/transport-agent/home')
				break;
			case 'businessowner':
				navigate('/management/home')		
				break;			
			default:
        cleanUp();
				toast.error('We are uanble to authenticate you. Please try loging in again.')
        const checkForRole = storePersist.get('google-login-role') || ''
        switch (checkForRole){
          case 'logistics_customer':		
            navigate('/auth/login/customer')
            break;
          case 'transporter':		
            navigate('/auth/login/transporter')
            break;
          case 'transportAgent':		
            navigate('/auth/login/transport-agent')
            break;
		  case 'employee':
				navigate('/auth/login/management')
				break;
          case 'businessowner':
            navigate('/auth/login/management')		
            break;			
          default:
            navigate('/')
        }
				
		}
	}

  function sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  const initiateLogin = async () => {
   
      const token = await dispatch(login({
        loginData: {
          "Records": [
            {
              "Context": {
                "Subscription": "ULIP",
                "Domain": "Logistics",
                "SubDomains": ["Delivery"],
                "Platform": "ULIP",
				"Application": "Customer",
                "Channel": 'CSP'
            },
              "Message": {
                "AccountType": "Logistics_Customer",
                "Username": "",
                "Password": "",
                "LoginWithOtp": false,
                "Otp": "",
                "ClientIPAddress": "",
                "IsGoogleAuthenticated": true,
                "AuthenticatedUserId": digitUserId
              }
            }
          ]
        }
      }))
      sleep(1000).then(async() => { 
        try{
			await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/iam/user-service/user-profile/me`, entity: 'userProfile' }))
			const userRole: any = await getAccountTypeChannalName();
			await gotoHome(userRole?.role);
  
        } catch (e: any) {
          // toast.error(e?.Error?.Message || 'There was an error in login. Please try again...')
          toast.error('There was an error in login. Please try again...')
          console.error('Failed to fetch profile:', e);
          navigate('/auth/login/customer')
        }
       });
      
    	
  }


useEffect(() => {
    initiateLogin();
}, [digitUserId]);

  return (
	<></>
  )
}